// @noflow
import { fetchWatchlist } from './actions';

const shouldFetchWatchlist = (state, prevState, dispatch) => {
  const {
    profiles: { currentProfile },
    viewer: { euid, uuid } = {},
    watchlist: {
      list: { fetching: fetchingWatchlist },
      mappingWasInitialized,
      watchlistIsStale,
    },
    networkInfo: { isInternetReachable },
  } = state;
  const {
    profiles: { currentProfile: prevCurrentProfile },
    viewer: { euid: prevEuid, uuid: prevUuid } = {},
    networkInfo: { isInternetReachable: prevIsInternetReachable },
  } = prevState;

  if (fetchingWatchlist || !isInternetReachable) {
    return;
  }

  if (
    // If the user has changed
    (euid && uuid && (prevEuid !== euid || prevUuid !== uuid)) ||
    // Profile has changed
    currentProfile?.profile?.id !== prevCurrentProfile?.profile?.id ||
    // Or a new item was added to watchlist
    watchlistIsStale ||
    // Mobile ONLY: Or if we've gained Internet and not yet fetching or have watchlist
    (!prevIsInternetReachable && isInternetReachable && !mappingWasInitialized)
  ) {
    dispatch(fetchWatchlist());
  }
};

export default store => next => action => {
  const { dispatch, getState } = store;
  const prevState = getState();
  next(action);
  const state = getState();

  shouldFetchWatchlist(state, prevState, dispatch);
};
